import { createAsyncAction, createStandardAction, AppThunk } from 'typesafe-actions';

import { HOTEL_LIST_SORT_VALUES } from 'constants/sort';
import { HotelItem } from 'HotelList-Types';
import {
  HotelListMap,
  HotelListMapErrors,
  HotelListMapRequestBody,
  HotelMapDetailsRequestBody,
} from 'HotelListMap-Types';
import { isInSortCategory } from 'store/utils';
import { fetchProviderDetails, fetchProviderLocationList } from './api';

import { getUserIdentifier } from 'store/common/selectors';
import { getDictionary } from '@travel/i18n';
import { updateSEOData } from 'store/seo/actions';
import { getTranslation } from '@travel/translation';

export const fetchHotelListMapAsync = createAsyncAction(
  'FETCH_HOTEL_LIST_MAP_REQUEST',
  'FETCH_HOTEL_LIST_MAP_SUCCESS',
  'FETCH_HOTEL_LIST_MAP_FAILURE',
)<undefined, HotelListMap, HotelListMapErrors>();

export const fetchHotelMapDetailsAsync = createAsyncAction(
  'FETCH_HOTEL_MAP_DETAILS_REQUEST',
  'FETCH_HOTEL_MAP_DETAILS_SUCCESS',
  'FETCH_HOTEL_MAP_DETAILS_FAILURE',
)<undefined, HotelItem, HotelListMapErrors>();

export const setHotelMapDetails = createStandardAction(
  'SET_HOTEL_MAP_DETAILS',
).map((payload: HotelItem) => ({ payload }));

export const clearHotelMapErrors = createStandardAction('CLEAR_HOTEL_MAP_ERRORS')();

export const fetchHotelListMap = (query: HotelListMapRequestBody): AppThunk => async (
  dispatch,
  getState,
  { apiClient },
) => {
  dispatch(fetchHotelListMapAsync.request());
  const userIdentifier = getUserIdentifier(getState());

  try {
    const clonedQuery = { ...query };
    if (!isInSortCategory(HOTEL_LIST_SORT_VALUES, clonedQuery.sort)) {
      clonedQuery.sort = HOTEL_LIST_SORT_VALUES.Provider_Recommend;
    }
    const response = await fetchProviderLocationList(apiClient, {
      ...clonedQuery,
      rzCookie: userIdentifier,
    });
    dispatch(fetchHotelListMapAsync.success(response));
  } catch (error) {
    dispatch(fetchHotelListMapAsync.failure(error as HotelListMapErrors));
  }
};

export const fetchHotelMapDetails = (query: HotelMapDetailsRequestBody): AppThunk => async (
  dispatch,
  getState,
  { apiClient },
) => {
  dispatch(fetchHotelMapDetailsAsync.request());
  const userIdentifier = getUserIdentifier(getState());

  try {
    const response = await fetchProviderDetails(apiClient, {
      ...query,
      rzCookie: userIdentifier,
    });
    dispatch(fetchHotelMapDetailsAsync.success(response));
  } catch (error) {
    dispatch(fetchHotelMapDetailsAsync.failure(error as HotelListMapErrors));
  }
};

export const fetchSEOData = (): AppThunk => async (dispatch, getState) => {
  const state = getState();
  const dictionary = getDictionary(state);
  const titleId = 'Domestic.JRDP.Hotel_List_Map.Static.Title';
  dispatch(
    updateSEOData({
      title: getTranslation(
        {
          id: titleId,
        },
        dictionary,
      )?.join(''),
      canonicalPath: '',
    }),
  );
};
